export default "__VITE_ASSET__DVFTY5tm__"